<template>
    <div class="content-wrapper">
        <div class="container-lg">
            <div class="row mb-12">
                <div class="col">
                    <div class="page-title-nav row">
                        <div class="col-2 col-lg-3">
                          <router-link class="btn btn-outline-secondary btn-custom btn-back" aria-current="page" :to="'/'">
                            <i
                                    class="fa-icon fa-regular fa-arrow-left me-0"></i><span
                                    class="d-none d-lg-block ms-2">ย้อนกลับ</span></router-link>
                        </div>
                        <div class="col-8 col-lg-6">
                            <h1 class="page-title">แนะนำเพื่อน</h1>
                        </div>
                        <div class="col-12 col-lg-3">
                            <a href="#" class="btn btn-primary btn-custom d-none"><i
                                    class="fa-icon fa-regular fa-home"></i><span>button</span></a>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="alert alert-info" role="alert">
                                <i class="fa-icon fa-solid fa-circle-info me-2"></i>ค่าคอมจ่ายเวลาตีหนึ่งของวันถัดไป
                            </div>
                            <div class="affiliate-url mb-4 d-flex flex-row gap-4">
                                <input    id="afurl" type="text" class="form-control form-control-sm" placeholder="Affiliate URL"
                                v-bind:value="pathname + getAffiliateLink"/>
                                <button  @click="copyURL" class="btn btn-primary btn-custom text-nowrap"><i
                                        class="fa-icon fa-regular fa-copy me-2"></i>คัดลอกลิงก์</button>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-lg-4">
                            <app-cardBalance :getCurrentIncome="getCurrentIncome"  />
                            <app-cardAffiliateQty :getDownline="getDownline" />

                        </div>
                        <div class="col-12 col-lg-8">
                            <div class="row">
                                <div class="col-12 col-lg-6">
                                    <app-cardAffiliateTotal :getTotalBet="numberWithCommas(getTotalBet)"/>
                                </div>
                                <div class="col-12 col-lg-6">
                                    <app-cardBalanceAffiliate :getTotalIncome="numberWithCommas(getTotalIncome)" />
                                </div>
                            </div>
                            <app-cardCommisionPerDay />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <app-cardAfMemberlist />
                        </div>
                    </div>
                </div>
            </div>
            <div class="push"></div>
        </div>
    </div>
</template>
<script>
import cardBalance from '@/components/sakha/affiliate/cardBalance'
import cardAffiliateQty from '@/components/sakha/affiliate/cardAffiliateQty'
import cardAffiliateTotal from '@/components/sakha/affiliate/cardAffiliatetotal'
import cardBalanceAffiliate from '@/components/sakha/affiliate/cardBalanceAffiliate'
// import cardCommision from '@/components/sakha/affiliate/cardCommision'
// import cardCommisionChild from '@/components/sakha/affiliate/cardCommisionChild'
import cardCommisionPerDay from '@/components/sakha/affiliate/cardCommisionPerDay'
import cardAfMemberlist from '@/components/sakha/affiliate/cardAfMemberlist'

import { mapActions, mapGetters } from 'vuex'
export default {
  components: {
    'app-cardBalance': cardBalance,
    'app-cardAffiliateQty': cardAffiliateQty,
    'app-cardAffiliateTotal': cardAffiliateTotal,
    'app-cardBalanceAffiliate': cardBalanceAffiliate,
    // 'app-cardCommision': cardCommision,
    // 'app-cardCommisionChild': cardCommisionChild,
    'app-cardCommisionPerDay': cardCommisionPerDay,
    'app-cardAfMemberlist': cardAfMemberlist
  },
  data () {
    return {
      pathname: window.location.origin
    }
  },
  mounted () {
    // this.pathname = this.pathname + this.getAffiliateLink
    // alert(this.pathname)
  },
  methods: {
    ...mapActions(['setLoading', 'getAffiliateInfo']),
    numberWithCommas (n) {
      // Remove existing commas first
      const cleanNumber = n.toString().replace(/,/g, '')

      // Convert to number and handle invalid inputs
      const x = Number(cleanNumber)
      if (isNaN(x)) return '0'

      // Format with commas
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    copyURL () {
      const el = document.getElementById('afurl')
      // alert(el.select())
      el.select()
      document.execCommand('copy')
      this.makeToast(true)
    },
    makeToast (append = false) {
      // alert('55555')
      this.$bvToast.toast('คัดลอกลิงค์แนะนำเรียบร้อยแล้ว', {
        noCloseButton: true,
        autoHideDelay: 1000,
        variant: 'success',
        appendToast: append,
        solid: false,
        toastClass: 'custom-toast'
      })
    }
  },
  async created () {
    this.setLoading(true)
    await this.getAffiliateInfo()
    this.setLoading(false)
  },
  computed: {
    ...mapGetters([
      'getAffiliateLink',
      'getCurrentIncome',
      'getTotalClick',
      'getTotalIncome',
      'getDownline',
      'getTotalBet'
    ])
  }
}
</script>
<style lang="less">
.btn-block {
    display: block !important;
    width: 100% !important;
}
.toast:not(.show) {
    display: block;
}
.custom-toast{
  display: block;
}
</style>
